/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import RelationshipActions from 'actions/RelationshipActions';
import MenuItem from 'components/MenuItem.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';

export default class BlockMemberMenuItem extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    blocked: PropTypes.bool,
    memberId: PropTypes.number.isRequired,
    memberName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };

  blockMember = (): void => {
    const { memberId, memberName } = this.props;
    RelationshipActions.block(memberId, memberName);
  };
  unblockMember = (): void => {
    const { memberId, memberName } = this.props;
    RelationshipActions.unblock(memberId, memberName);
  };
  renderConfirmDialog() {
    const { memberName } = this.props;
    return (
      <ConfirmDialog
        eventScreenName="BlockMemberMenuItem"
        actionButtonText="Block"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.blockMember}
        title={`Block ${memberName}?`}
        subtext={'You will no longer be able to direct message or add them to your classes.'}
      />
    );
  }

  render() {
    if (this.props.blocked) {
      return (
        <MenuItem
          onClick={this.unblockMember}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-unblock-${
            this.props.memberId
          }`}>
          <Glyph name="disabled" />
          <span>Unblock user</span>
        </MenuItem>
      );
    } else {
      return (
        <ModalMenuItem
          modal={this.renderConfirmDialog()}
          disabled={this.props.disabled}
          data-test-selector={`conversation-sidebar-participant-menu-block-${this.props.memberId}`}>
          <Glyph name="disabled" />
          <span>Block user</span>
        </ModalMenuItem>
      );
    }
  }
}
